import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { usePersistedStore } from '../store/persisted-store';

const Home = () => {
  const { auth } = usePersistedStore();
  const navigate = useNavigate(); 
  const userToken = auth.userToken;

  useEffect(() => {
    if (userToken) {
      navigate("/dashboard");
    } else {
      navigate("/auth"); 
    }
  }, [userToken, navigate]); 

  return <div></div>;
};

export default Home;
